/**
 * API Configuration
 * Determines the API base URL based on environment
 */

import { auth } from '../firebase/config';

const getApiBase = () => {
  // Check if we're in development with local server
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1';
  
  // Check environment variable (set in build process)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default: localhost for development, Firebase Functions for production
  if (isLocalhost) {
    return 'http://localhost:3001/api';
  } else {
    // Firebase Cloud Function URL
    // The function is deployed at: https://us-central1-muso-ninjas-80a45.cloudfunctions.net/metadataApi
    // Routes are at /api/*, so we append /api
    return 'https://us-central1-muso-ninjas-80a45.cloudfunctions.net/metadataApi/api';
  }
};

export const API_BASE = getApiBase();

/**
 * Get authentication headers for API requests
 * Includes Firebase ID token if user is authenticated
 */
export const getAuthHeaders = async () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  
  try {
    const user = auth.currentUser;
    if (user) {
      const token = await user.getIdToken();
      headers['Authorization'] = `Bearer ${token}`;
    }
  } catch (error) {
    console.warn('Could not get auth token:', error);
    // Continue without token - API may work without auth
  }
  
  return headers;
};

// Export for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('API_BASE:', API_BASE);
}

